<template lang="pug">
  .component-reservation-action-buttons
    .dropdown-buttons
      EditPlanReservationRates(:rate-id="item.id")
      button.button.alert(@click="remove") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper"
  import {EventBus} from "../../../../eventBus";
  import EditPlanReservationRates from "../../../backoffice/tabbed/EditPlanReservationRates.vue";

  export default {
    name: "PlanReservationRateActionButtons",
    components: {EditPlanReservationRates},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove() {
        this.$confirm('Are you sure?', 'Do you really want delete this plan reservation rate?', () => {
          KeplerBackofficeSdk.planReservationRates.select(this.item).remove(() => {
            MaggieHelper.notification('Deleted', 'Plan reservation rate deleted successfully')
            EventBus.$emit('reload-list')
          })
        })
      },

    },
    computed: {},
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PlanReservationRateActionButtons.vue?11e03861